type baseEnvUrls = {
  development: string;
  test: string;
  uat: string;
  production: string;
};

const assetsBaseUrls: baseEnvUrls = {
  development: 'https://assets.fastly.zagforward.com',
  test: 'https://assets.fastly.carvanatech.com',
  uat: 'https://resources.fastly.cvuat.com',
  production: 'https://assets.fastly.carvana.io'
};
const apimBaseUrls: baseEnvUrls = {
  development: 'https://apim.zagforward.com',
  test: 'https://apim.carvanatech.com',
  uat: 'https://apim.cvuat.com',
  production: 'https://apim.carvana.io'
};

const apigBaseUrls: baseEnvUrls = {
  development: 'https://apig.zagforward.com',
  test: 'https://apig.carvanatech.com',
  uat: 'https://apig.carvanatech.com',
  production: 'https://apig.carvana.io'
};

const currentApigBaseUrls = (environment: string): string => apigBaseUrls[environment as keyof typeof apigBaseUrls];
const currentAssetsUrl = (environment: string): string => assetsBaseUrls[environment as keyof typeof assetsBaseUrls];
const currentApimUrl = (environment: string): string => apimBaseUrls[environment as keyof typeof apimBaseUrls];

export { currentApigBaseUrls, currentAssetsUrl, currentApimUrl };
